import BackboneElement from '../BackboneElement';
import merge from 'lodash/merge';
import CodeableConcept from '@/fhirworks/types/CodeableConcept';

/**
 * A PRN dose given past one of its order's limits, and why.
 *
 * The breached limit is coded beside the free text so reporting can read it off the record
 * rather than re-derive it from an order that may since have been edited.
 */
export default class LimitOverride extends BackboneElement {
    static __className = 'LimitOverride';

    __objectStructure = {
        // over-daily-maximum | too-soon, one coding per limit breached
        limit: CodeableConcept,
        reason: String,
    };

    constructor(constructJson, className = 'LimitOverride') {
        super(constructJson, className);

        this.createAndPopulateStructure(this.__objectStructure, constructJson, this.__objectDefaults);
        this.originalObjJson = this.toJSON();
    }

    toJSON() {
        return merge(super.toJSON(this), this.getJsonForStructure(this.__objectStructure));
    }
}
